// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

function MarkdownComponent(props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <h2 id="enables-approved-organizations-to-submit-benefits-related-pdfs-and-access-information-on-a-veteran%E2%80%99s-behalf.">Enables approved organizations to submit benefits-related PDFs and access information on a Veteran’s behalf.</h2>
    </div>
  );
};

export default MarkdownComponent;
